import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SubmittableForm } from 'src/app/models/base/submittable-form.base';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent extends SubmittableForm {
  @Input() errText: string | undefined;

  constructor(private activeModal: NgbActiveModal, translateService: TranslateService)
  {
    super(translateService)
  }

  dismissModal()
  {
    this.activeModal.dismiss();

    this.errText = undefined;
  }

}
